// import React from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider, useAuth } from './context/AuthContext';
// import AdminLayout from './components/AdminLayout';
// import LoginPage from './pages/LoginPage';
// import DashboardPage from './pages/DashboardPage';
// import ProjectsPage from './pages/ProjectsPage';
// import ProjectFormPage from './pages/ProjectFormPage';
// import QuotationsPage from './pages/QuotationsPage';
// import ContactsPage from './pages/ContactsPage';
// import TestimonialsPage from './pages/TestimonialsPage';
// import ServicesPage from './pages/ServicesPage';
// import SettingsPage from './pages/SettingsPage';

// const ProtectedRoute = ({ children }) => {
//   const { user, loading } = useAuth();
//   if (loading) return (
//     <div className="min-h-screen bg-surface-900 flex items-center justify-center">
//       <div className="w-10 h-10 border-2 border-brand-400 border-t-transparent rounded-full animate-spin" />
//     </div>
//   );
//   return user ? children : <Navigate to="/login" replace />;
// };

// const PublicRoute = ({ children }) => {
//   const { user, loading } = useAuth();
//   if (loading) return null;
//   return user ? <Navigate to="/" replace /> : children;
// };

// export default function App() {
//   return (
//     <AuthProvider>
//       <BrowserRouter>
//         <Routes>
//           <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
//           <Route path="/" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
//             <Route index element={<DashboardPage />} />
//             <Route path="projects" element={<ProjectsPage />} />
//             <Route path="projects/new" element={<ProjectFormPage />} />
//             <Route path="projects/edit/:id" element={<ProjectFormPage />} />
//             <Route path="quotations" element={<QuotationsPage />} />
//             <Route path="contacts" element={<ContactsPage />} />
//             <Route path="testimonials" element={<TestimonialsPage />} />
//             <Route path="services" element={<ServicesPage />} />
//             <Route path="settings" element={<SettingsPage />} />
//           </Route>
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </BrowserRouter>
//     </AuthProvider>
//   );
// }

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import LoginPage from './pages/LoginPage';
import AdminLayout from './components/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectFormPage from './pages/ProjectFormPage';
import ProjectMediaPage from './pages/ProjectMediaPage';
import CategoriesPage from './pages/CategoriesPage';
import ServicesPage from './pages/ServicesPage';
import TestimonialsPage from './pages/TestimonialsPage';
import QuotationsPage from './pages/QuotationsPage';
import ContactsPage from './pages/ContactsPage';
import SettingsPage from './pages/SettingsPage';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-surface-900">
      <div className="text-white/40 text-sm">Loading...</div>
    </div>
  );
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
           <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} /> 
           <Route path="/" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}> 
            <Route index element={<DashboardPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/new" element={<ProjectFormPage />} />
            <Route path="projects/:id/edit" element={<ProjectFormPage />} />
            <Route path="projects/:id/media" element={<ProjectMediaPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="testimonials" element={<TestimonialsPage />} />
            <Route path="quotations" element={<QuotationsPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route> 
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: '#1e2433', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px' },
            success: { iconTheme: { primary: '#dc7b28', secondary: '#fff' } },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}